import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class Authentication {
  login(data) {
    return axios.post(BASE_URL + "/admin/auth/loginUser", data)
  }

  verifyLogin(data) {
    return axios.post(BASE_URL + "/admin/auth/verifyOtp", data)
  }

  getUserDetailsById(config) {
    return axios.get(BASE_URL + "/admin/auth/getUserDetailById", config)
  }

  getAnalyst(config) {
    return axios.get(BASE_URL + "/admin/auth/getAnalystusers", config)
  }

  createUser(data, config) {
    return axios.post(BASE_URL + "/admin/auth/createUser", data, config)
  }
  forgotPassword(data,config){
    return axios.post(BASE_URL + "/admin/auth/forgotPassword", data, config)
  
  }
  verifyForgotOtp(data,config){
    return axios.post(BASE_URL + "/admin/auth/verifyForgotOtp", data, config)
  
  }
  resetPassword(data,config){
    return axios.post(BASE_URL +"/admin/auth/resetPassword",data,config)
  }
  changePassword(data,config){
    return axios.post(BASE_URL + "/admin/auth/changePassword",data,config)
  }
}

export default new Authentication()
